import { Injectable } from "@angular/core";
import { BreadcrumbModel } from "@modules/common/models/BreadcrumbModel";
import { CompleteUrlBuilderService } from '@modules/common/services/complete-url-builder.service';

@Injectable({
    providedIn: 'root'
})
export class RefreshDataBreadcrumbsService {
    constructor(
        private _completeUrlBuilderService: CompleteUrlBuilderService
    ) { }

    public getBreadcrumbsModel(args: { basePageTitle?: string, basePageLocation?: string, currentPageTitle?: string, currentPageRouteName?: string }): BreadcrumbModel[] {
        const result = [{
            title: args.basePageTitle || '',
            url: this.getUrl(args.basePageLocation || '')
        }];

        if (args.currentPageRouteName) {
            result.push({
                title: args.currentPageTitle || args.currentPageRouteName,
                url: this.getUrl(args.currentPageRouteName)
            });
        }

        return result;
    }

    private getUrl(page: string): string {
        return this._completeUrlBuilderService.buildUrl(['DataRefresh', page]);
    }

}
